import usePageLayout from '../../../hooks/usePageLayout';
import '../StoryStatistic/StoryStatistic.scss';
import React, { useLayoutEffect, useRef } from "react";
import { useLocation, useParams } from 'react-router-dom';
import { Helmet } from "react-helmet";
import ButtonPanelReaction from '../../../components/Buttons/ButtonPanelReaction';
import ButtonReactionAdd from '../../../components/Buttons/ButtonReactionAdd';
import StoryTitle from '../../../components/StoryTitle';
import PostUser from "../../../components/PostUser";
import StoryDetailFilters from '../../../components/StoryDetailFilters';
import InlineNotice from '../../../components/Brand/InlineNotice';
import useStoryFilters from '../../../hooks/useStoryFilters';
import { useTranslation } from 'react-i18next';
import { Layout } from 'antd';
import ContentState from '../../../components/Brand/ContentState';
import BrandLoader from '../../../components/Brand/BrandLoader';
import useStoryDetails from '../../../hooks/useStoryDetails';
import useOpinionTypes from '../../../hooks/useOpinionTypes';
import useInAppView from '../../../inApp/useInAppView';
import OpinionTypeFilter from '../../../components/OpinionTypeFilter';
import './StoryUsers.scss';

const { Header, Content, Footer } = Layout;
export default function StoryUsers() {
	const params = useParams();
	const location = useLocation();
	const storyId = parseInt(params.storyId);
	const filters = useStoryFilters(storyId, 'opinions');
	const { list: reactions, story, status, retained, noticeKey, retry } = useStoryDetails(storyId, 'opinions', {
		initialStory: location.state?.storyPreview, area: filters.area, query: filters.query,
		composing: filters.composing, viewerKey: filters.viewerKey,
	});
	const { types, visibleReactions, toggleType } = useOpinionTypes(reactions, `${storyId}:${filters.viewerKey}`);

	const ref_header = useRef(null);
	const ref_footer = useRef(null);
	const listRef = useRef(null);
	useLayoutEffect(() => {
		if (listRef.current) listRef.current.scrollTop = 0;
	}, [types, reactions]);
	const { contentHeight, contentTop } = usePageLayout(ref_header, ref_footer);
	const { t } = useTranslation();
	const emptyKey = reactions.length && !visibleReactions.length ? 'opinionTypesEmpty'
		: filters.query.trim() ? 'storySearchEmpty'
		: filters.area === 'all' ? 'opinionsEmpty' : 'storyFilteredOpinionsEmpty';

	const reactionItems = visibleReactions.map((r) =>
		<PostUser key={r.id} telemetryActorId={r.user?.id} author={r.user} scope={r.scope} msg_flg={r.text_msg} reactionId={r.id} storyId={storyId} story={story} source="opinions" />
	);
	const hasVisibleList = !noticeKey && (status === 'ready' || retained) && visibleReactions.length > 0;
	useInAppView({ kind: 'respondents', storyId, title: story.title, listRef,
		ready: status === 'ready' && !noticeKey && visibleReactions.length > 0,
		resetKey: `${filters.viewerKey}:${filters.area}:${filters.query}:${visibleReactions.map(item => item.id).join(',')}` });

	return (
		<Layout className="app-layout story-detail-page">
			<Helmet>
				<title>{story.title}</title>
				<meta name="description" content={story.title} />
			</Helmet>
			<Header ref={ref_header} className="header">
				<h1 className="story-detail-heading">{t('story.opinions')}</h1>
				<StoryDetailFilters mode="opinions" {...filters} />
				<div className="wrapper-padding">
					<StoryTitle
						activeSection="opinions"
						detailArea={filters.area}
						storyId={storyId}
						title={story.title}>
					</StoryTitle>
				</div>
			</Header>
			<Content
				className="content-layot"
				style={{ height: contentHeight, top: contentTop }}
				aria-busy={status === 'loading'}
			>
				{retained && <BrandLoader className="brand-loader--refresh" label={t('brand:loading')} />}
				<div className={`story-users-viewport${hasVisibleList ? ' story-users-viewport--fade' : ''}`}>
					<div ref={listRef} inert={retained ? '' : undefined}
						className={`story-users-wrapper people-list loading-retained-content${!hasVisibleList ? ' story-users-wrapper--state' : ''}`}>
						{noticeKey ? <div className="story-detail-notice"><InlineNotice>{t(`brand:${noticeKey}`)}</InlineNotice></div>
							: status !== 'ready' && !retained ? <ContentState status={status} onRetry={retry} />
							: visibleReactions.length ? reactionItems : <>
								<ContentState status="empty" emptyKey={emptyKey} />
								{!reactions.length && filters.area === 'all' && !filters.query.trim() && <div className="story-empty-opinion-action"><ButtonReactionAdd storyId={storyId} story={story} /></div>}
							</>}
					</div>
				</div>
			</Content>
			<Footer ref={ref_footer}>
				{/* Type selection is local, so it can also be chosen before a pending
				    response or retry. Audience permissions remain enforced by the API. */}
				<div aria-busy={status === 'loading'}>
					<OpinionTypeFilter types={types} onToggle={toggleType} />
				</div>
				<ButtonPanelReaction storyId={storyId} />
			</Footer>
		</Layout>
	)
}
